import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startPortalBridge } from "./portal/portalBridge";
import { startDocumentLocale } from "./i18n/documentLocale";
import "./index.css";
import "./localization.css";

// Before React mounts: the portal may answer jp:ready with the player at once.
// Standalone (not in an iframe) this does nothing.
startPortalBridge();
startDocumentLocale();

const host = document.getElementById("root");
if (!host) throw new Error("#root is missing from index.html");

/**
 * No StrictMode: the page owns one Phaser canvas and one socket, and a
 * deliberate double-mount would open a second of each. The mount paths guard
 * against it anyway, but there is nothing to gain from provoking it here.
 */
createRoot(host).render(<App />);
